import { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

import { formatters } from 'reactUtils/formatters'

import { Skeleton } from 'lmcv/components/Skeleton'
import { pluralize } from 'lmcv/modules/utils'

import * as S from './styled'

function Points ({ user, isLoading }) {
  const CurrentPoints = () => (
    <Fragment>
      {formatters.toDecimal(user.points.actual)}{' '}
      {pluralize('pt', user.points.actual > 1)}
    </Fragment>
  )

  const ExpireDate = () => (
    <Fragment>
      {formatters.toDecimal(user.points.toExpire)}{' '}
      {user.points.toExpire === 1 ? 'expira' : 'expiram'} dia{' '}
      {dayjs(user.points.expireAt).format('DD/MM/YYYY')}
    </Fragment>
  )

  return (
    <S.Header>
      <S.TextBalance>Seu saldo total é de:</S.TextBalance>

      <S.TicketBox>
        <S.Ticket>
          <S.TicketValue>
            {isLoading
              ? ('0 pt')
              : (<CurrentPoints />)
            }
          </S.TicketValue>
        </S.Ticket>
        <S.TextExpiration>
          {isLoading
            ? (<Skeleton width="140px" height="13px" />)
            : (<ExpireDate />)
          }
        </S.TextExpiration>
      </S.TicketBox>
    </S.Header>
  )
}

Points.propTypes = {
  user: PropTypes.shape({
    points: PropTypes.shape({
      actual: PropTypes.number,
      toExpire: PropTypes.number
    })
  }).isRequired
}

export default memo(Points)
